import { z } from "zod";

export const AppErrorCodeSchema = z.enum([
  "AUTH_REQUIRED",
  "NETWORK_ERROR",
  "VALIDATION_ERROR",
  "RATE_LIMITED",
  "AI_UNAVAILABLE",
  "SAFETY_FLOW_REQUIRED",
  "SUBSCRIPTION_REQUIRED",
  "CONTENT_NOT_FOUND",
  "UNKNOWN_ERROR",
]);

export type AppErrorCode = z.infer<typeof AppErrorCodeSchema>;
